/** Counts describe completed work in the named stage, never an estimated percentage. */
export interface OperationProgress { stage: string; completed?: number; total?: number; }
export type ProgressReporter = (progress: OperationProgress) => void;

export function renderOperationProgress(element: HTMLElement, { stage, completed, total }: OperationProgress): void {
  element.setAttribute("role", "status");
  const counted = Number.isSafeInteger(total) && total! >= 0 && Number.isSafeInteger(completed) && completed! >= 0 && completed! <= total!;
  element.textContent = counted ? `${stage} · ${completed} of ${total}` : stage;
  const bar = element.ownerDocument.createElement("progress"); bar.setAttribute("aria-label", stage);
  if (counted) { bar.max = Math.max(1, total!); bar.value = completed!; }
  element.append(bar);
}

/** Appears only during a long operation; not another persistent toolbar control. */
export function createWorkspaceProgress(document: Document): (value: OperationProgress | null) => void {
  let element: HTMLElement | null = null;
  return value => {
    if (!value) { element?.remove(); element = null; return; }
    const host = document.querySelector(".content");
    if (!host) return;
    if (!element?.isConnected) { element = document.createElement("div"); element.className = "workspace-operation-progress"; host.prepend(element); }
    renderOperationProgress(element, value);
  };
}
